﻿import type {
  DateFilterModel,
  NumberFilterModel,
  ProvidedFilterModel,
  SetFilterModel,
  TextFilterModel,
} from 'ag-grid-community';

export interface FilterTranslator<FilterModel extends ProvidedFilterModel = ProvidedFilterModel, TOuput = string> {
  filterType: string;
  col?: string;
  translate: (filterModel: FilterModel, colId?: string) => Nullable<TOuput>;
}

export const dateTranslator: () => FilterTranslator<DateFilterModel> = () => ({
  filterType: 'date',
  translate: filterModel => filterModel.dateFrom ?? null,
});
export const setTranslator: () => FilterTranslator<SetFilterModel> = () => ({
  filterType: 'set',
  translate: filterModel => filterModel.values.join(','),
});
export const textTranslator: () => FilterTranslator<TextFilterModel> = () => ({
  filterType: 'text',
  translate: filterModel => filterModel.filter ?? null,
});
export const numberTranslator: () => FilterTranslator<NumberFilterModel> = () => ({
  filterType: 'number',
  translate: filterModel => {
    return filterModel.filter?.toString() ?? null;
  },
});
